module.exports = __webpack_public_path__ + "img/form.f196587.webp";